import { render } from "./GuoCangHeader.vue?vue&type=template&id=40d7c48e&ts=true"
import script from "./GuoCangHeader.vue?vue&type=script&lang=ts"
export * from "./GuoCangHeader.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__